import baustein from "baustein";
import forms from "web/script/dom/forms";
import analytics from "web/script/analytics/analytics";
import environment from "web/script/modules/environment";
import requester from "web/script/modules/requester";
import globals from "web/script/modules/globals";
import overlayMixin from "web/script/components/mixins/overlay-mixin";

export default baustein.register("country-overlay", {
    mixins: [overlayMixin],

    defaultOptions: {
        overlaySize: "small",
    },

    setupEvents: function(add) {
        add("submit", "form", this.onSubmit);
    },

    onOverlayOpen: function() {
        analytics.event("SETTINGS", "SHOW_COUNTRY_OVERLAY");
    },

    onOverlayCloseIntent: function() {
        this.close();
    },

    /**
     * Submit event handler
     * @param {object} event The event object
     */
    onSubmit: function(event) {
        var form = event.target;
        var formData = forms.serialize(form);

        event.preventDefault();

        requester(form.action, {
            method: "POST",
            body: formData,
            headers: {
                Accept: "text/html",
            },
        })
            .then(
                function() {
                    var newCountry = formData.country;
                    var oldCountry = environment.get("country");
                    return this.trackChangeOfCountry(oldCountry, newCountry);
                }.bind(this)
            )
            .then(
                function() {
                    return this.close();
                }.bind(this)
            )
            .then(function() {
                globals.window.location.reload(true);
            });
    },

    /**
     * Track the change of country
     * @param  {string} oldCountry Previous country code
     * @param  {string} newCountry New country code
     * @return {Promise} Will resolve once tracking is complete
     */
    trackChangeOfCountry: function(oldCountry, newCountry) {
        return analytics.event("SETTINGS", "CHANGE_COUNTRY", oldCountry + "-to-" + newCountry);
    },

    /**
     * Get the overlay content which is obviously html :(
     */
    getOverlayContent: function() {
        return requester("/account/set_country/", {
            headers: {
                Accept: "text/html",
            },
        }).then(function(response) {
            return response.text();
        });
    },
});
